import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.updateFactoringProfileLoading"],
  loading => loading
);
